import api from './api';

export interface Sector {
  id: string;
  name: string;
  description: string | null;
  regulator: string | null;
  createdAt: string;
  productCount?: number;
}

export interface SectorsListResponse {
  sectors: Sector[];
  total: number;
}

export const sectorService = {
  /**
   * Get all sectors
   */
  async getAllSectors(): Promise<SectorsListResponse> {
    const response = await api.get('/sectors');
    return response.data;
  },

  /**
   * Get single sector by ID
   */
  async getSector(id: string): Promise<Sector> {
    const response = await api.get(`/sectors/${id}`);
    return response.data;
  },
};


